var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"list-group-item text-left"},[_c('BMedia',{scopedSlots:_vm._u([{key:"aside",fn:function(){return [_c('BImg',{attrs:{"alt":_vm.displayName,"src":_vm.icon,"height":"24","width":"24"},on:{"error":_vm.failedImageHandler}})]},proxy:true}])},[_c('h5',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.displayName)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }